import * as dateFnsCompat from 'utils/date-fns-compat';

import fp from 'lodash/fp';
import 'moment-duration-format';
import React from 'react';
import { TooltipWrapper } from '../containers/pages/app/partials/tooltip-wrapper';
import { taskTypes } from '../containers/pages/app/tasks/config';
import link from '../images/glyphicon-basic/glyphicons-basic-351-link@x.png';
import paperclip from '../images/glyphicon-basic/glyphicons-basic-63-paperclip@x.png';
import education from '../images/glyphicon-basic/glyphicons-basic-68-education@x.png';
import { unfixedFloor } from '../utils';
import { attachFullName } from './areas-of-advice';

var moment = require('moment');

export const forbidPropagate = (e) => {
  e.stopPropagation();
};

export const getCpdCategory = (
  { cpdCategorys = [], contents = [], courses = [] },
  allCpdCategorys = [],
  industryCpdCategory = []
) => {
  const industryCpdCategoryWithFullName = attachFullName(industryCpdCategory);

  const getCatId = (item) => item.cpdCategoryId || item.id;

  const isIndustryCategory = (item) => {
    const catId = getCatId(item);
    return !industryCpdCategory || industryCpdCategory.length === 0
      ? true
      : !!fp.find(({ id }) => id === catId)(industryCpdCategory);
  };

  const contentCatPoints = fp.flow(
    fp.flatMap('cpdCategorys'),
    fp.filter(isIndustryCategory)
  )(contents);

  const courseCatPoints = fp.flow(
    fp.flatMap('cpdCategorys'),
    fp.filter(isIndustryCategory)
  )(courses);

  const taskCatPoints = fp.filter(isIndustryCategory)(cpdCategorys);

  const allCategoryEntries = [
    ...contentCatPoints,
    ...courseCatPoints,
    ...taskCatPoints
  ];

  if (allCategoryEntries.length === 0) {
    return 'n/a';
  }

  const groupedByCatId = fp.groupBy(getCatId)(allCategoryEntries);

  const fullCpdCategory = Object.keys(groupedByCatId).map((catIdStr) => {
    const catId = Number(catIdStr) || catIdStr;
    const entries = groupedByCatId[catIdStr];

    const totalPoints = fp.sumBy((item) =>
      Number(item.points || item.cpdPoints || 0)
    )(entries);

    const aoaWithFullName = fp.find(({ id }) => id === catId)(
      industryCpdCategoryWithFullName
    );
    const fullCategoryObj =
      fp.find(({ id }) => id === catId)(allCpdCategorys) || {};

    const name = aoaWithFullName
      ? aoaWithFullName.name
      : fullCategoryObj.name || 'Unknown Category';

    const categoryType =
      fullCategoryObj.categoryType ||
      (aoaWithFullName && aoaWithFullName.categoryType) ||
      'Other';

    return {
      cpdCategoryId: catId,
      name,
      categoryType,
      points: totalPoints > 0 ? totalPoints : null
    };
  });

  if (fullCpdCategory.length === 0) {
    return 'n/a';
  }

  const isMultiple = fullCpdCategory.length > 1;
  const categoryLabel = isMultiple ? 'Multiple' : fullCpdCategory[0].name;

  return (
    <TooltipWrapper
      fullCpdCategory={fullCpdCategory}
      category={categoryLabel}
      className={isMultiple ? 'multiple-cpd-trigger' : undefined}
      trigger={['focus', 'click']}
      clickHandler={forbidPropagate}
    />
  );
};

export const getTaskType = ({ contents, links }) => {
  if (contents.length > 0) {
    return taskTypes.CADDIE;
  } else if (links.length > 0) {
    return taskTypes.EXTERNAL;
  } else {
    return taskTypes.ATTACHMENT;
  }
};

export const getTaskTypeIcon = ({ attachments, contents, links }) => {
  if (attachments.length > 0) {
    return <img className='task-type-icon' src={paperclip} alt='attachment' />;
  }
  if (contents.length > 0) {
    return <img className='task-type-icon' src={education} alt='caddie' />;
  }
  if (links.length > 0) {
    return <img className='task-type-icon' src={link} alt='external' />;
  }
};

export const getCpdHours = ({ cpdCategorys, contents, courses }) => {
  return unfixedFloor(
    fp.flow(fp.flatMap('cpdCategorys'), fp.sumBy('points'))(contents) +
      fp.flow(
        fp.flatMap(({ cpdCategorys }) => cpdCategorys),
        fp.sumBy(({ cpdPoints }) => cpdPoints)
      )(courses),
    2
  );
};

export const getDueDateText = (dueDate) => {
  const diffNano = dateFnsCompat.differenceInMilliseconds(
    dateFnsCompat.startOfDay(dueDate),
    dateFnsCompat.startOfToday()
  );
  const pastDue = diffNano < 0;
  const diff = moment.duration(Math.abs(diffNano), 'milliseconds');
  const diffDefault = diff.format().split(',')[0];
  const diffDay = parseInt(diff.format('d').replace(/\D/, ''), 10);
  const payAttention = pastDue ? true : diffDay < 2;
  const defaultText = pastDue ? `${diffDefault} ago` : `In ${diffDefault}`;
  const specialText =
    diffDay > 1
      ? undefined
      : diffDay === 0
        ? 'Today'
        : pastDue
          ? 'Yesterday'
          : 'Tomorrow';

  return {
    dueDateText: specialText ? specialText : defaultText,
    pastDue,
    payAttention
  };
};



// WEBPACK FOOTER //
// ./src/services/task.js